import { render, staticRenderFns } from "./BuyCourse.vue?vue&type=template&id=3b2a60bd&scoped=true&"
import script from "./BuyCourse.vue?vue&type=script&lang=js&"
export * from "./BuyCourse.vue?vue&type=script&lang=js&"
import style0 from "./BuyCourse.vue?vue&type=style&index=0&id=3b2a60bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a60bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItem,VListItemTitle})
